import React from 'react';

function PowerStrip() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_241_1151)">
        <path
          d="M18.6023 70.416L16.3403 72.678C15.7163 73.302 14.7023 73.302 14.0783 72.678L7.29027 65.89C6.66627 65.266 6.66627 64.252 7.29027 63.628L9.55227 61.366L18.6023 70.416Z"
          fill="#E0DDDA"
        />
        <path
          d="M52.5479 7.37984L7.38216 52.5456C5.5342 54.3935 5.5342 57.3897 7.38216 59.2376L20.7635 72.6189C22.6114 74.4669 25.6075 74.4669 27.4555 72.6189L72.6212 27.4532C74.4692 25.6052 74.4692 22.6091 72.6212 20.7611L59.24 7.37984C57.392 5.53188 54.3959 5.53188 52.5479 7.37984Z"
          fill="#F7F4F1"
        />
        <path
          d="M64.9562 24.0939L61.2782 27.6599C60.7362 28.1859 59.8262 28.1399 59.2582 27.5559L52.4482 20.5639C51.8802 19.9799 51.8582 19.0719 52.4022 18.5459L56.0802 14.9799C56.6222 14.4539 57.5322 14.4999 58.1002 15.0839L64.9102 22.0759C65.4782 22.6599 65.5002 23.5679 64.9562 24.0939Z"
          fill="white"
        />
        <path
          d="M73.1863 20.196L59.8043 6.81402C57.6483 4.65802 54.1383 4.65802 51.9823 6.81402L6.81427 51.98C4.65827 54.136 4.65827 57.646 6.81427 59.802L8.39827 61.386L6.72427 63.06C5.78827 63.996 5.78827 65.518 6.72427 66.454L13.5123 73.242C13.9803 73.71 14.5943 73.944 15.2083 73.944C15.8223 73.944 16.4383 73.71 16.9063 73.242L18.5803 71.568L20.1963 73.184C21.2743 74.262 22.6903 74.802 24.1083 74.802C25.5263 74.802 26.9423 74.262 28.0203 73.184L73.1863 28.018C75.3423 25.862 75.3423 22.352 73.1863 20.196ZM15.7743 72.112C15.4623 72.424 14.9543 72.424 14.6423 72.112L7.85427 65.324C7.54227 65.012 7.54227 64.504 7.85427 64.192L9.52827 62.518L17.4483 70.438L15.7743 72.114V72.112ZM72.0543 26.888L26.8883 72.054C25.3563 73.586 22.8623 73.586 21.3283 72.054L19.2943 70.02C19.2603 69.96 19.2203 69.9 19.1683 69.848L10.1183 60.798C10.0683 60.748 10.0083 60.708 9.94827 60.672L7.94627 58.67C6.41427 57.136 6.41427 54.644 7.94627 53.11L53.1123 7.94602C53.8783 7.18002 54.8863 6.79602 55.8923 6.79602C56.8983 6.79602 57.9063 7.18002 58.6723 7.94602L72.0543 21.328C73.5863 22.862 73.5863 25.354 72.0543 26.888Z"
          fill="#84827E"
        />
        <path
          d="M58.6742 14.5261C57.7982 13.6261 56.3842 13.5721 55.5242 14.4061L51.8462 17.9721C51.4442 18.3621 51.2182 18.8941 51.2102 19.4681C51.2022 20.0741 51.4442 20.6781 51.8762 21.1221L58.6862 28.1141C59.1462 28.5861 59.7542 28.8261 60.3522 28.8261C60.8942 28.8261 61.4262 28.6301 61.8342 28.2341L65.5122 24.6681C65.9142 24.2781 66.1402 23.7461 66.1482 23.1721C66.1562 22.5661 65.9142 21.9621 65.4822 21.5181L58.6722 14.5261H58.6742ZM64.4002 23.5201L60.7222 27.0861C60.4982 27.3041 60.0902 27.2621 59.8322 26.9981L53.0222 20.0061C52.8842 19.8641 52.8062 19.6761 52.8082 19.4921C52.8082 19.3881 52.8362 19.2401 52.9582 19.1221L56.6362 15.5561C56.7342 15.4621 56.8642 15.4161 57.0042 15.4161C57.1862 15.4161 57.3802 15.4941 57.5262 15.6441L64.3362 22.6361C64.4742 22.7781 64.5522 22.9661 64.5502 23.1501C64.5502 23.2541 64.5222 23.4021 64.4002 23.5201Z"
          fill="#84827E"
        />
        <path
          d="M52.8965 33.4521V31.4041H54.4924C53.9964 28.0221 51.0904 25.4241 47.5704 25.4241C44.0504 25.4241 41.1464 28.0221 40.6484 31.4041H42.2444V33.4521H40.6484C41.1444 36.8341 44.0504 39.4321 47.5704 39.4321C51.0904 39.4321 53.9944 36.8341 54.4924 33.4521H52.8965ZM47.5724 36.5641C46.8364 36.5641 46.2404 35.9681 46.2404 35.2321C46.2404 34.4961 46.8364 33.9001 47.5724 33.9001C48.3084 33.9001 48.9044 34.4961 48.9044 35.2321C48.9044 35.9681 48.3084 36.5641 47.5724 36.5641ZM47.5724 30.9521C46.8364 30.9521 46.2404 30.3561 46.2404 29.6201C46.2404 28.8841 46.8364 28.2881 47.5724 28.2881C48.3084 28.2881 48.9044 28.8841 48.9044 29.6201C48.9044 30.3561 48.3084 30.9521 47.5724 30.9521Z"
          fill="url(#paint0_linear_241_1151)"
        />
        <path
          d="M27.7587 58.59V56.542H29.3547C28.8587 53.16 25.9527 50.562 22.4327 50.562C18.9127 50.562 16.0087 53.16 15.5107 56.542H17.1067V58.59H15.5107C16.0067 61.972 18.9127 64.57 22.4327 64.57C25.9527 64.57 28.8567 61.972 29.3547 58.59H27.7587ZM22.4347 61.702C21.6987 61.702 21.1027 61.106 21.1027 60.37C21.1027 59.634 21.6987 59.038 22.4347 59.038C23.1707 59.038 23.7667 59.634 23.7667 60.37C23.7667 61.106 23.1707 61.702 22.4347 61.702ZM22.4347 56.09C21.6987 56.09 21.1027 55.494 21.1027 54.758C21.1027 54.022 21.6987 53.426 22.4347 53.426C23.1707 53.426 23.7667 54.022 23.7667 54.758C23.7667 55.494 23.1707 56.09 22.4347 56.09Z"
          fill="url(#paint1_linear_241_1151)"
        />
        <path
          d="M40.3281 46.0219V43.9739H41.9241C41.4281 40.5919 38.5221 37.9939 35.0021 37.9939C31.4821 37.9939 28.5781 40.5919 28.0801 43.9739H29.6761V46.0219H28.0801C28.5761 49.4039 31.4821 52.0019 35.0021 52.0019C38.5221 52.0019 41.4261 49.4039 41.9241 46.0219H40.3281ZM35.0041 49.1339C34.2681 49.1339 33.6721 48.5379 33.6721 47.8019C33.6721 47.0659 34.2681 46.4699 35.0041 46.4699C35.7401 46.4699 36.3361 47.0659 36.3361 47.8019C36.3361 48.5379 35.7401 49.1339 35.0041 49.1339ZM35.0041 43.5219C34.2681 43.5219 33.6721 42.9259 33.6721 42.1899C33.6721 41.4539 34.2681 40.8579 35.0041 40.8579C35.7401 40.8579 36.3361 41.4539 36.3361 42.1899C36.3361 42.9259 35.7401 43.5219 35.0041 43.5219Z"
          fill="url(#paint2_linear_241_1151)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_241_1151"
          x="3.79727"
          y="3.79702"
          width="75.6064"
          height="75.605"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.6" dy="1.6" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_241_1151"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_241_1151"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_241_1151"
          x1="42.5956"
          y1="26.677"
          x2="52.1189"
          y2="37.4729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_241_1151"
          x1="17.4579"
          y1="51.8149"
          x2="26.9813"
          y2="62.6109"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_241_1151"
          x1="30.0272"
          y1="39.2468"
          x2="39.5506"
          y2="50.0427"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PowerStrip;
